import apiRequest from './apiRequest';

export default async function getPose(jobID: string) {
  const { data, error } = await apiRequest<{
    bvhURL: string;
    studioPreviewURL: string;
    title: string;
  }>('mogen-orchestration', `/v2/poses/${jobID}`);

  return { data, error };
}
